var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDesktopKiwiBg = function SvgDesktopKiwiBg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1044.37,
    height: 927.742,
    viewBox: "0 0 1044.37 927.742",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18581",
    "data-name": "Group 18581",
    transform: "translate(-441.162 93.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-165",
    d: "M268.251-3.276C38.687,24.153,44.427,305.212,30.082,428.754S-13.634,884.211,369.755,858.722s229.109-333.542,184.3-395.277-84.3-119.548-71.831-229.306S497.814-30.611,268.251-3.276Z",
    transform: "matrix(-0.454, -0.891, 0.891, -0.454, 729.602, 851.563)",
    fill: "#bcf1ff",
    opacity: 0.649
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17100",
    "data-name": "Group 17100",
    transform: "translate(738 262.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersection_25",
    "data-name": "Intersection 25",
    d: "M-.641,125.029c.675-15.122,5.156-32.13,27.73-44.363C64.895,60.18,33.475,35.4,33.475,35.4H3.238C16.681,26.545,20.3-12.269,55.406,3.894,85.1,17.564,113.632,78.138,103.144,114.756c-16.188,14.734-36.536,23.508-58.637,23.508A84.438,84.438,0,0,1-.641,125.029Z",
    transform: "translate(84.222 54.465)",
    fill: "#b2926e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M81.43,6.24c-9.46.782-25.771,10.753-50.636,32.5S-1.655,76.667.29,79.922s17.7-12.092,50.672-27.758,51.665-14.682,66.464-23.607S132.982,4.389,126.246.682s-10.981,9-20.547,6.965A83.257,83.257,0,0,0,81.43,6.24Z",
    transform: "matrix(0.914, 0.407, -0.407, 0.914, 32.647, 22.091)",
    fill: "#fec95f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14166",
    "data-name": "Group 14166",
    transform: "translate(76.379 17.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ellipse",
    d: "M15.03,0c8.486.153,15.516,9.56,15.7,21.009s-6.54,20.607-15.026,20.454S.191,31.906,0,20.456,6.544-.151,15.03,0Z",
    transform: "translate(6.68 6.788) rotate(9.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    d: "M18.891,4.731C18.962,4.07,13.478-.082,9.907,0,3.745.109.072,8.813,0,9.474S5.17,3.5,9.623,2.645,18.82,5.392,18.891,4.731Z",
    transform: "translate(0.988 3.605) rotate(-11)",
    fill: "#b2926e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    "data-name": "path",
    d: "M21.706,3.009c2.9,4.422.68,12.146-4.964,17.247s-12.57,5.638-15.468,1.2S.592,9.308,6.237,4.206,18.807-1.431,21.706,3.009Z",
    transform: "translate(1.086 25.915) rotate(-34)",
    fill: "#b2926e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-4",
    "data-name": "path",
    d: "M13.566,1.875c1.807,2.766.414,7.594-3.1,10.773S2.6,16.178.791,13.394.377,5.8,3.9,2.621,11.758-.892,13.566,1.875Z",
    transform: "translate(6.982 26.931) rotate(-34)",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    "data-name": "path",
    d: "M3.769,4.139c.489-1.868.078-3.77-.9-4.091S.691,1.041.205,2.984s-.078,3.77.9,4.091S3.283,6.082,3.769,4.139Z",
    transform: "matrix(-0.875, -0.485, 0.485, -0.875, 15.314, 25.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ellipse-2",
    "data-name": "ellipse",
    d: "M17.147,0c9.787.263,17.982,11.1,18.3,24.2S28.1,47.721,18.315,47.459.332,36.36.01,23.256,7.36-.258,17.147,0Z",
    transform: "matrix(0.965, 0.263, -0.263, 0.965, 34.591, 6.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-6",
    "data-name": "path",
    d: "M23.915,3.42c3.223,4.992.807,13.67-5.405,19.378S4.65,29.07,1.428,24.058.621,10.387,6.833,4.679,20.693-1.593,23.915,3.42Z",
    transform: "translate(28.109 27.556) rotate(-28)",
    fill: "#b2926e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-7",
    "data-name": "path",
    d: "M14.947,2.131c2.009,3.123.492,8.547-3.38,12.1S2.9,18.163.887,15.019.4,6.472,4.268,2.915,12.938-.992,14.947,2.131Z",
    transform: "translate(34.496 29.424) rotate(-28)",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-8",
    "data-name": "path",
    d: "M4.227,4.591C4.768,2.524,4.3.414,3.2.055S.763,1.145.225,3.3.15,7.473,1.253,7.832,3.688,6.742,4.227,4.591Z",
    transform: "translate(44.143 28.896) rotate(-147)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-9",
    "data-name": "path",
    d: "M8.841,20.156C9.358,19.731,12.8,10.839,9.9,5.364S.55-.279.034.146s5.012,1.516,7.8,6.919S8.325,20.582,8.841,20.156Z",
    transform: "translate(55.598 6.778) rotate(-11)",
    fill: "#b2926e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9293",
    "data-name": "Path 9293",
    d: "M4.895,21.407C-1.458,31.826.193,41.344.193,41.344L26.861,9.422,23.848,0S11.247,10.989,4.895,21.407Z",
    transform: "translate(141.925 87.688) rotate(-16)",
    fill: "#a78866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9291",
    "data-name": "Path 9291",
    d: "M1.135,58.973s-4.7-9.5,5.025-24.16A210.854,210.854,0,0,1,21.85,14.379c1.471-1.7,3.7-4.162,5.894-6.424C32.859,2.678,37.971-1.2,40.029.342c4.561,3.431,1.778,37.032-6.133,63.1",
    transform: "translate(151.037 71.166) rotate(-2)",
    fill: "#b2926e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9290",
    "data-name": "Path 9290",
    d: "M1.349,57.064s-5.043-9.541,4.373-23.711A191,191,0,0,1,21.008,13.664c1.44-1.637,3.623-3.994,5.78-6.159C31.813,2.455,36.876-1.216,39.007.376c3.82,2.861,4.066,23.752.154,45.317-.882,4.865-2.028,9.94-3.41,14.812",
    transform: "translate(170.925 72.749) rotate(24)",
    fill: "#b2926e",
    opacity: 0.302
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9292",
    "data-name": "Path 9292",
    d: "M1.035,58.092S-3.465,48.875,6.3,34.42A214.665,214.665,0,0,1,22.011,14.235c1.47-1.686,2.916-3,5.106-5.24,5.1-5.228,10.965-10.21,12.971-8.731,4.443,3.287,2.4,34.1-5.73,59.675",
    transform: "translate(136.565 78.163) rotate(-13)",
    fill: "#b2926e",
    opacity: 0.302
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9294",
    "data-name": "Path 9294",
    d: "M.02,4.058c-.394-1.545,5.195,1.092,9.8.118S18.927-1.36,20.263.4s-2.744,8.663-8.875,9.962S.411,5.608.02,4.058Z",
    transform: "translate(116.413 79.424) rotate(7)",
    fill: "#e5b452"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDesktopKiwiBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/desktopKiwiBg.4676a631.svg";
export { ForwardRef as ReactComponent };